import { useEffect, useState } from "react"
import { ServerDate } from "@/helpers/server-date.class"
import {
  countdownSeconds,
  formatCountdown
} from "@/hooks/useBattleScreen/helpers"

const TICK_MS = 1000

export const useBattleCountdown = (
  deadline: string | null,
  active: boolean
): string => {
  const [nowMs, setNowMs] = useState(() => ServerDate.now())

  useEffect(() => {
    if (!active) {
      return
    }
    setNowMs(ServerDate.now())
    const timerId = window.setInterval(
      () => setNowMs(ServerDate.now()),
      TICK_MS
    )
    return () => window.clearInterval(timerId)
  }, [deadline, active])

  return formatCountdown(countdownSeconds(deadline, nowMs))
}
